import { BookitupDocumentType } from '../Types/BookitupDocument';
// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { DocumentTemplateDto, DocumentType, PositionDto } from './DocumentT';
import { ajaxActions } from './AjaxActions';
import { patchPosition } from './restapi/positionService';
import { ToastS } from './ToastS';
import { ConstantS } from './ConstantS';
import { MixpanelS } from './MixpanelS';

const BASE_URL = process.env.REACT_APP_DOCUMENT_SERVICE_URL;

const create = async (type: DocumentType, name: string): Promise<DocumentTemplateDto | null> => {
  const res = await ajaxActions.put(`${BASE_URL}/templates/${type}/${name}`);
  if (res.ok) {
    MixpanelS.track(ConstantS.TrackingEvents.DocumentTemplateCreated);
    ToastS.info('template-created', 'Vorlage erstellt');
    return res.json();
  }
  ToastS.generalError();
  return null;
};

const fetchTemplate = async (type: BookitupDocumentType, name: string) => {
  const resp = await ajaxActions.get(`${BASE_URL}/report/template/${type.toUpperCase()}/${name}`);
  if (resp.ok) {
    return resp.json();
  }
  ToastS.generalError();
  return null;
};

const fetchAll = (documentType: BookitupDocumentType): Promise<string[]> =>
  ajaxActions.get(`${BASE_URL}/report/template/${documentType}/names`).then((resp) => {
    if (resp.ok) {
      return resp.json();
    }
    // eslint-disable-next-line no-console
    console.error(`Unable to load templates per documentType: ${documentType}`);
    return [];
  });

const edit = async (id: number, patch: Partial<DocumentTemplateDto>): Promise<DocumentTemplateDto | null> => {
  const res = await ajaxActions.patch(`${BASE_URL}/templates/${id}`, patch);
  if (res.ok) {
    return res.json();
  }
  ToastS.generalError();
  return null;
};

const remove = async (type: DocumentType, name: string): Promise<boolean> => {
  const res = await ajaxActions.del(`${BASE_URL}/documentTemplates/${type}/${name}`);
  if (res.ok) {
    ToastS.info('template-removed', 'Vorlage entfernt');
    return true;
  }
  ToastS.generalError();
  return false;
};

const insertPosition = async (
  templateId: number,
  targetPositionId?: number,
  position?: Partial<PositionDto>,
): Promise<DocumentTemplateDto | null> => {
  const res = await ajaxActions.put(
    `${BASE_URL}/templates/v2/${templateId}/positions${
      targetPositionId ? `?targetPositionId=${targetPositionId}` : ''
    }`,
    position,
  );
  if (res.ok) {
    return res.json();
  }
  ToastS.generalError();
  return null;
};

const removePosition = async (id: number, positionId: number): Promise<DocumentTemplateDto | null> => {
  const res = await ajaxActions.del(`${BASE_URL}/templates/v2/${id}/positions/${positionId}`);
  if (res.ok) {
    ToastS.info('Position entfernt', 'Position entfernt');
    return res.json();
  }
  ToastS.generalError();
  return null;
};

const movePosition = async (templateId: number, fromId: number, toId: number): Promise<DocumentTemplateDto | null> => {
  const res = await ajaxActions.patch(
    `${BASE_URL}/templates/v2/${templateId}/positions?fromId=${fromId}&toId=${toId}`,
    null,
  );
  if (res.ok) {
    return res.json();
  }
  ToastS.generalError();
  return null;
};

const swapPositions = async (
  templateId: number,
  direction: string,
  positionId: number,
): Promise<DocumentTemplateDto | null> => {
  const res = await ajaxActions.patch(
    `${BASE_URL}/templates/${templateId}/swap/${direction}?positionId=${positionId}`,
    null,
  );
  if (res.ok) {
    return res.json();
  }
  ToastS.generalError();
  return null;
};

const insertProducts = async (
  templateId: number,
  productIds: number[],
  targetPositionId?: number,
): Promise<DocumentTemplateDto | null> => {
  const res = await ajaxActions.put(
    `${BASE_URL}/templates/${templateId}/products${targetPositionId ? `?targetPositionId=${targetPositionId}` : ''}`,
    productIds,
  );
  if (res.ok) {
    ToastS.info('foo', 'Produkte eingefügt.');
    return res.json();
  }
  ToastS.generalError();
  return null;
};

// eslint-disable-next-line import/prefer-default-export
export const DocumentTemplateS = {
  create,
  fetchTemplate,
  fetchAll,
  edit,
  remove,
  insertPosition,
  patchPosition,
  removePosition,
  movePosition,
  swapPositions,
  insertProducts,
};
